
import React from 'react';
import _ from 'underscore';
import { PreviewGeneral } from './preview-general';

const getPreview = (
  video, previewTexts, i18n, isCurrent,
  activityLogger, previewSetting, customThumbnail
) => {
  let propsToPass = {
    video,
    previewTexts,
    i18n,
    isCurrent,
    activityLogger,
    customThumbnail,
  };

  propsToPass = _.defaults(
    propsToPass,
    previewSetting
  );

  return (<PreviewGeneral {...propsToPass} />);
};

export {
  getPreview
};
